import { Dispatch } from "react";
import styled from "styled-components";

import FormAddress from "components/templates/signUp/Form/FormAddress";
import InputFile from "components/templates/signUp/Form/File";
import { H4, H5 } from "components/atoms/text";
import InputText from "components/atoms/input/Text";
import COLORS from "components/atoms/colors";

import SignUpCompany from "types/dto/SignUpCompany";
import Action from "types/Action";
import Address from "types/Address";

interface Props {
  signUpState: SignUpCompany;
  onDispatch: Dispatch<Action>;
  companyAddress: Address;
  onDispatchAddress: (option: { key: string; value: any }) => void;
}

const FormCompany = ({
  signUpState,
  onDispatch,
  companyAddress,
  onDispatchAddress,
}: Props) => {
  const {
    name,
    contactNumber,
    managerName,
    managerNumber,
    site,
    license,
    email,
  } = signUpState;

  const { postCode, baseAddress, detailAddress } = companyAddress;

  return (
    <>
      <InputContainer>
        <div>
          <H5 className="mb-3">
            기업명<Essential>*</Essential>
          </H5>
          <InputText
            placeholder="기업명을 입력하세요."
            name="name"
            value={name}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
        <div>
          <H5 className="mb-3">기업 사이트</H5>
          <InputText
            placeholder="사이트 주소를 입력하세요."
            name="site"
            value={site}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
      </InputContainer>

      <InputContainer>
        <div>
          <H5 className="mb-3">
            기업 연락처<Essential>*</Essential>
          </H5>
          <InputText
            placeholder="연락처를 입력하세요."
            name="contactNumber"
            value={contactNumber}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
        <div>
          <H5 className="mb-3">
            이메일<Essential>*</Essential>
          </H5>
          <InputText
            placeholder="이메일을 입력하세요."
            name="email"
            value={email}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
      </InputContainer>

      <InputContainer>
        <div>
          <H5 className="mb-3">
            이름<Essential>*</Essential>
          </H5>
          <InputText
            placeholder="이름을 입력하세요."
            name="managerName"
            value={managerName}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
        <div>
          <H5 className="mb-3">
            휴대전화번호<Essential>*</Essential>
          </H5>
          <InputText
            placeholder="휴대전화번호를 입력하세요."
            name="managerNumber"
            value={managerNumber}
            onChange={(event) => onDispatch({ event })}
            shape="round"
          />
        </div>
      </InputContainer>

      <InputContainer>
        <div>
          <H5 className="mb-3">
            사업자등록증 or 명함<Essential>*</Essential>
          </H5>
          <InputFile
            name="businessLicense"
            file={license}
            onDispatch={(option) => onDispatch({ option })}
          />
        </div>
        <div />
      </InputContainer>

      <TitleWrap className="mt-10">
        <H4>
          주소<Essential>*</Essential>
        </H4>
        <TitleLine />
      </TitleWrap>

      <p className="mb-5 text-sm">
        주소 입력란은 샘플 배송을 위한 필수 항목입니다.{" "}
        <br className="hidden md:block" /> 샘플을 받으실 주소를 입력해주세요.
      </p>

      <FormAddress
        addressState={{ postCode, baseAddress, detailAddress }}
        chageEvent={{
          onChageDetail: (value) =>
            onDispatchAddress({ key: "detailAddress", value }),
          onChageBase: (value) =>
            onDispatchAddress({ key: "baseAddress", value }),
          onChagePostCode: (value) =>
            onDispatchAddress({ key: "postCode", value }),
        }}
        className="w-[400px]"
        shape="round"
      />
    </>
  );
};

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;

  & > div {
    flex: 1;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Essential = styled.span`
  vertical-align: top;
  color: ${COLORS.error.active};
  font-size: 16px;
`;

const TitleWrap = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  ${H4} {
    flex: none;
  }
`;

const TitleLine = styled.span`
  display: block;
  flex: 1;
  height: 1px;
  background: ${COLORS.black["20%"]};
`;

export default FormCompany;
